/**
 * The `BlogsPage` function returns a component that renders a `CardsHome` component.
 * @returns The BlogsPage component is returning the CardsHome component.
 */
import React from "react";
import SearchBar from "../component/SearchBar";
import CardsHome from "../component/CardsHome";

const BlogsPage = () => {
  return (
    
      <CardsHome />
 
  );
};

export default BlogsPage;
